document.addEventListener('DOMContentLoaded', function() {
    // Select all elements with the 'scrollappear' class
    const elements = document.querySelectorAll('.scrollappear');
    
    // Set initial opacity to 0 for all elements
    elements.forEach(element => {
        element.style.opacity = '0';
        element.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out';
        element.style.transform = 'translateY(20px)';
    });
    
    // Create an Intersection Observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // If the element is in the viewport
            if (entry.isIntersecting) {
                // Add a small delay before animation for a nicer effect
                setTimeout(() => {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }, 100);
                
                // Stop observing the element after it has appeared
                observer.unobserve(entry.target);
            }
        });
    }, {
        // Element is considered "visible" when it's 10% in the viewport
        threshold: 0.1,
        // Start loading earlier for a smoother experience
        rootMargin: '0px 0px -50px 0px'
    });
    
    // Start observing each element
    elements.forEach(element => {
        observer.observe(element);
    });
});
